// @flow

import type { JSONValue } from 'common/types';

export default function literal<V>(value: V): JSONValue => V {
  return _json => value;
}
